import { AxiosResponse } from "axios";
import { api } from "./base/api";
import { Result } from "../models/common/resultResponse";
import { KeyValue } from "../models/common";
import { IClaimFileCategoryApi } from "./base";

const baseRoute: string = "ClaimFileCategory";

export class ClaimFileCategoryApi extends IClaimFileCategoryApi {
	getDomain(): Promise<AxiosResponse<Result<KeyValue[]>>> {
		return api.get(`${baseRoute}/getDomain`);
	}
}
